"use strict";

exports.__esModule = true;
exports.getYoutubeId = void 0;

/**
 *
 * @param {string} url
 * @return {string | undefined}
 */
var getYoutubeId = function getYoutubeId(url) {
  var idVideoYoutube = null;
  var matches = url.match(/https:\/\/((youtu\.be)|(www\.youtube\.com))\/(watch\?v=)?(.+)/);

  if (matches) {
    idVideoYoutube = matches[5];
    return idVideoYoutube;
  }

  return undefined;
};

exports.getYoutubeId = getYoutubeId;